import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { dummyDisputeChats } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./DisputeDetailsPage.css";

const formatDateTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso || "N/A";
  }
};

const DisputeDetailsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId, disputeData } = location.state || {};

  if (!disputeData) {
    return (
      <main className="dashboard-main dashboard-subpage dispute-details-page">
        <div className="dashboard-body">
          <button type="button" className="dispute-details-back" onClick={() => navigate("/dashboard/dispute_management")}>
            <i className="fas fa-arrow-left" /> Dispute Details
          </button>
          <p>No dispute data found.</p>
        </div>
      </main>
    );
  }

  const d = disputeData;
  const ad = d.adInfo || {};
  const buyerEmail = d.buyerInfo?.emailId ?? "N/A";
  const sellerEmail = d.sellerInfo?.emailId ?? "N/A";
  const price = d.fiatAmount != null && d.cryptoAmount != null && Number(d.cryptoAmount) !== 0
    ? (Number(d.fiatAmount) / Number(d.cryptoAmount)).toFixed(2)
    : "N/A";
  const chatMessages = (orderId && dummyDisputeChats[orderId]) || [];
  const hasPaymentProof = false; // dummy: no proof

  return (
    <main className="dashboard-main dashboard-subpage dispute-details-page">
      <div className="dashboard-body">
        <button type="button" className="dispute-details-back" onClick={() => navigate("/dashboard/dispute_management")}>
          <i className="fas fa-arrow-left" /> Dispute Details
        </button>

        <div className="dispute-details-grid">
          <section className="dispute-details-card dispute-details-card--order">
            <h2 className="dispute-details-card__header">Order Details</h2>
            <div className="dispute-details-card__body dispute-details-card__body--scroll">
              <div className="dispute-details-row">
                <span className="dispute-details-label">Order ID</span>
                <span className="dispute-details-value">{d._id || "N/A"}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Status</span>
                <span className="dispute-details-badge dispute-details-badge--dispute">DISPUTE</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Dispute By</span>
                <span className={`dispute-details-badge dispute-details-badge--by dispute-details-badge--${(d.disputeBy || "").toLowerCase()}`}>{d.disputeBy || "N/A"}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Dispute Reason</span>
                <span className="dispute-details-value">{d.disputeReason || "N/A"}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Crypto Amount</span>
                <span className="dispute-details-value dispute-details-value--bold">{d.cryptoAmount} {ad.qouteCurrency || ""}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Fiat Amount</span>
                <span className="dispute-details-value dispute-details-value--bold">{d.fiatAmount} {ad.fiatCurrency || ""}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Price</span>
                <span className="dispute-details-value">{price} {ad.fiatCurrency || ""}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Buyer</span>
                <span className="dispute-details-value">{buyerEmail}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Seller</span>
                <span className="dispute-details-value">{sellerEmail}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Ad ID</span>
                <span className="dispute-details-value">{ad.adUid || "N/A"}</span>
              </div>
              <div className="dispute-details-row">
                <span className="dispute-details-label">Created At</span>
                <span className="dispute-details-value">{formatDateTime(d.createdAt)}</span>
              </div>
            </div>
          </section>

          <section className="dispute-details-card dispute-details-card--payment">
            <h2 className="dispute-details-card__header">Payment Proof</h2>
            <div className="dispute-details-card__body dispute-details-payment-placeholder">
              {hasPaymentProof ? (
                <div>Payment proof image / link</div>
              ) : (
                <>
                  <i className="fas fa-file-invoice dispute-details-payment-icon" />
                  <p className="dispute-details-payment-text">No payment proof uploaded</p>
                </>
              )}
            </div>
          </section>
        </div>

        <section className="dispute-details-card dispute-details-chat">
          <div className="dispute-details-card__header-row">
            <h2 className="dispute-details-card__header">Buyer and Seller Chat</h2>
            <span className="dispute-details-chat-badge">{chatMessages.length} messages</span>
          </div>
          <div className="dispute-details-card__body dispute-details-chat-body">
            {chatMessages.length === 0 ? (
              <p className="dispute-details-chat-empty">No messages</p>
            ) : (
              chatMessages.map((msg, i) => (
                <div key={i} className={`dispute-details-msg dispute-details-msg--${msg.from.toLowerCase()}`}>
                  <div className="dispute-details-msg-bubble">
                    <div className="dispute-details-msg-meta">{msg.emailId} · {formatDateTime(msg.sentAt)}</div>
                    <div className="dispute-details-msg-content">{msg.content}</div>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>

        <section className="dispute-details-email-actions">
          <h3 className="dispute-details-email-title">Send Email to User</h3>
          <div className="dispute-details-email-buttons">
            <button type="button" className="dispute-details-email-btn dispute-details-email-btn--grey">
              <i className="fas fa-envelope" /> Request Payment Proof
            </button>
            <button type="button" className="dispute-details-email-btn dispute-details-email-btn--grey">
              <i className="fas fa-envelope" /> Request Additional Info
            </button>
            <button type="button" className="dispute-details-email-btn dispute-details-email-btn--grey">
              <i className="fas fa-envelope" /> Request Verification
            </button>
            <button type="button" className="dispute-details-email-btn dispute-details-email-btn--yellow">
              <i className="fas fa-envelope" /> Custom Email
            </button>
          </div>
        </section>

        <section className="dispute-details-resolve-actions">
          <button type="button" className="dispute-details-resolve-btn dispute-details-resolve-btn--cancel">
            Cancel with Reason
          </button>
          <button type="button" className="dispute-details-resolve-btn dispute-details-resolve-btn--favor-buyer">
            Favor Buyer
          </button>
          <button type="button" className="dispute-details-resolve-btn dispute-details-resolve-btn--favor-seller">
            Favor Seller
          </button>
        </section>
      </div>
    </main>
  );
};

export default DisputeDetailsPage;
